// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2u-2";
export var placeholderIcon = "_2u-3";
export var thumbnailCanvas = "_2u-1";
export var thumbnailWrapper = "_2u-0";